import { makeUserManager } from 'react-oidc'
import { identityAuthority } from './apiConfig'

const identityConfig = {
  authority: identityAuthority, // Use full backend URL for IdentityServer
  client_id: 'SignInBookClient',
  redirect_uri: `${window.location.origin}/SignInCallback`,
  response_type: 'token id_token',
  scope: 'openid profile api',
  post_logout_redirect_uri: `${window.location.origin}/LoggedOut`
}

const userManager = makeUserManager(identityConfig)

export default userManager
